exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".bannerDetail .bannerForm{width:80%}.bannerDetail .el-radio{display:block;width:200px}.bannerDetail .el-radio+.el-radio{margin-left:0}.bannerDetail .el-input{margin-top:10px}.bannerDetail .wxApp-from{margin-left:120px;margin-bottom:10px}.wx-app{margin-bottom:0}.bannerDetail .place{width:30%}.bannerContent{min-width:700px;width:70%}.gray{color:#999}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-4c3f4234!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/yunying/banner/newBanner.vue
// module id = 518
// module chunks = 0